import React from "react";
import SupportPageLayout from "../components/layout/SupportPageLayout";

const ReturnsPage = () => {
  return (
    <SupportPageLayout
      title="Returns and Exchanges"
      description="A visible returns policy helps build buyer confidence before checkout."
      path="/returns"
    >
      <section>
        <h2 className="text-2xl font-light text-white">Requesting a return</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          If there is an issue with your order, contact us as soon as possible
          with your order number, photos when relevant, and a short description
          of the issue.
        </p>
      </section>
      <section>
        <h2 className="text-2xl font-light text-white">Eligibility</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Unused, unopened and undamaged items are generally the easiest to
          review for return or exchange approval. For hygiene-sensitive items,
          approval may depend on product type and condition.
        </p>
      </section>
      <section>
        <h2 className="text-2xl font-light text-white">How to get help</h2>
        <p className="mt-3 leading-relaxed text-gray-300">
          Email{" "}
          <a className="text-amber-300 hover:text-amber-200" href="mailto:hello@jmolux.com">
            hello@jmolux.com
          </a>{" "}
          and our support team will guide you through the next step.
        </p>
      </section>
    </SupportPageLayout>
  );
};

export default ReturnsPage;
